module.exports = __webpack_public_path__ + "img/full4-min.ea817e9c.png";